/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NumberOfTabsToShow/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function NumberOfTabsToShow({
  children,
  viewPath = "/App/Account/Topbar/Tabs/More/Content/NumberOfTabsToShow",
  onChange
  
}) {
let listValueData = fromData.useDataValue({ viewPath,
context: 'list',
})
let tabsNumberOfTabsToShowValueData = fromData.useDataValue({ viewPath,
context: 'tabs',
path: 'number_of_tabs_to_show',
})
let tabsNumberOfTabsToShowChangeData = fromData.useDataChange({ viewPath,
context: 'tabs',
path: 'number_of_tabs_to_show',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 marginLeft={dtSpaceXs}
 marginRight={dtSpaceXs}
 maxWidth={200}
 marginTop={0}
 size="small"
 data="list"
 from={listValueData}
 data="tabs.number_of_tabs_to_show"
 value={tabsNumberOfTabsToShowValueData}
 onChange={tabsNumberOfTabsToShowChangeData}
 flexDirection="row"
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}